import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "selection-row" }
const _hoisted_2 = { class: "upload-container" }
const _hoisted_3 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_4 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_5 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_6 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_7 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_8 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_9 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_10 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_11 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_12 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_13 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_14 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_15 = {
  key: 0,
  class: "el-form-item__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-position": "top" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.payeesList.length > 0)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Выбрать существующего получателя",
              class: _normalizeClass([{ 'is-error': _ctx.showErrors && !_ctx.selectedPayee }, "selection-item"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.selectedPayee,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPayee) = $event)),
                  placeholder: "Выбрать получателя"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: 'new',
                      label: "Новый получатель",
                      value: null
                    })),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payeesList, (payee) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: payee.id,
                        label: payee.name,
                        value: payee
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { class: "selection-item" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_upload, {
                action: "",
                "auto-upload": false,
                "on-change": _ctx.handleFileChange,
                "before-upload": _ctx.beforeUpload,
                limit: 1,
                "file-list": _ctx.fileList,
                "on-remove": _ctx.handleRemoveFile,
                ref: "uploadRef"
              }, {
                tip: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "el-upload__tip" }, "Загрузите файл с инвойсом - наш сервис автоматически заполнит все поля", -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Загрузить файл с инвойсом")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-change", "before-upload", "file-list", "on-remove"]),
              (_ctx.isProcessingFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_icon, { class: "loading-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    }),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "loading-text" }, "Файл обрабатывается", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_form_item, {
        label: "Наименование получателя",
        class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.name })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_el_form_item, { label: "Наименование получателя (англ.)" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.nameEn,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nameEn) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.nameEn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Номер импортного контракта" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.importContractNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.importContractNumber) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.importContractNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Номер инвойса" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.invoiceNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.invoiceNumber) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.invoiceNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Адрес получателя" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.address,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Адрес получателя (англ.)" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.addressEn,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addressEn) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.addressEn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Расчетный счет получателя" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.account,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.account) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.account)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Наименование банка получателя" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.bankName,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bankName) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.bankName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Наименование банка получателя (англ.)" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.bankNameEn,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bankNameEn) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.bankNameEn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Адрес банка получателя" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.bankAddress,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bankAddress) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.bankAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Адрес банка получателя (англ.)" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.bankAddressEn,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bankAddressEn) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.bankAddressEn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "SWIFT получателя" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.bankSwift,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.bankSwift) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.bankSwift)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Это поле обязательное"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}